import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 14, viewBox: "0 0 17 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 10L4 13L16 1", stroke: "currentColor" }));
export default SvgCheck;
